module.exports = __webpack_public_path__ + "img/red-pita-04.b0a7da05.png";